<template>
	<div class="popin" :class="{ 'is-open':isOpen }" aria-hidden="false" id="popin-horse" v-if="goodHorse">
		<div class="popin__container" :class="{ 'loading-blur': !actual }">

			<button class="popin__close" @click="close">
				<span class="icon icon--close" aria-hidden="true" title="Fermer"></span>
				<span class="visually-hidden">Fermer</span>
			</button>

			<div class="popin__header">
				<span class="icon icon--info popin__header__icon" aria-hidden="true"></span>
				{{ horse.name.toUpperCase() }}
			</div>

			<div class="popin__content">
				<table class="table-small">
					<tbody>
					<tr>
						<th>Entraîneur</th>
						<td>{{ horse.trainer.toUpperCase() }}</td>
					</tr>
					<tr>
						<th>Propriétaire</th>
						<td>{{ horse.owner }}</td>
					</tr>
					<tr>
						<th>Sexe</th>
						<td>{{ t('racecard.horse.gender.'+horse.gender).toUpperCase() }}</td>
					</tr>
					<tr>
						<th>Âge</th>
						<td>{{ horse.age }}</td>
					</tr>
					<tr v-if="horse.colour">
						<th>Robe</th>
						<td>{{ horse.colour }}</td>
					</tr>
					<tr v-if="runner.blinkers">
						<th>Œillères</th>
						<td>{{ runner.blinkers == 1 ? t('racecard.horse.blinkers.yes') : t('racecard.horse.blinkers.no') }}</td>
					</tr>
					<tr v-if="runner.horseshoe !== null">
						<th>Déferré</th>
						<td>{{ runner.horseshoe }}</td>
					</tr>
					<tr v-if="horse.rasse">
						<th>Race</th>
						<td>
							{{ horse.rasse }}
						</td>
					</tr>
					<tr v-if="lastForms && lastForms.weight">
						<th>Poids</th>
						<td>{{ lastForms.weight }} Kg</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import {instance} from '@/api';
	import {raceApi} from '@/api';
	import Popper from 'popper.js';

	export default {
		name: 'HorsePopup',
		props: [
			'runner'
		],
		data() {
			return {
				isOpen: !!this.runner,
				popper: null,
				horse: null,

				more: {}
			}
		},
		beforeDestroy(){
			if(this.popper !== null){
				this.popper.destroy();
			}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			goodHorse() {
				return this.horse && this.horse.name;
			},
			lastRunners() {
				if (this.more.runners && this.more.runners.length > 0) {
					return this.more.runners[0];
				}

				return null;
			},
			lastForms() {
				if (this.more.forms && this.more.forms.length > 0) {
					return this.more.forms[0];
				}

				return null;
			},
			actual() {
				return this.more.id && this.horse.id && this.horse.id === this.more.id;
			}

		},
		watch: {
			runner(val) {
				if (val) {
					this.horse = val.horse;
					this.getHorse(val.horse.id);
					if(this.popper !== null){
						this.popper.destroy();
					}
					this.togglePopup(true);

				} else {
					this.horse = null;
				}
				this.isOpen = !!val;
			},
			isOpen(val){
				this.togglePopup(val);
			}
		},
		mounted() {
			if (this.runner) {
				this.horse = this.runner.horse;
				this.getHorse(this.runner.horse.id);
			}
			if(this.isOpen){
				this.togglePopup(true);
			}
			window.Popper = Popper;


		},
		methods: {

			close() {
				this.isOpen = false;
				this.$emit('hide');
			},
			getHorse(id) {
				instance.get(raceApi.horse + id).then((responce) => {
					if (responce.data.status === 'SUCCESS') {
						this.more = responce.data.content.horse;
					}
				})
			},
			togglePopup(state){



				this.$nextTick(()=>{

					if(state){
						let ref = document.querySelector('#table__bet__info__runner--' + this.runner.id);
						let tgt = this.$el;
						this.popper = new Popper(ref, tgt, {
							positionFixed: true,
							placement: 'bottom'
						})
					}else if(this.popper !== null){
						this.popper.destroy();
					}
				})

			}
		}
	}
</script>
<style>

</style>